<template>
    <div class="teacher-index-container">
        <div class="header">
            当前位置:
            <div style="margin-left: 5px;">
                <span>
                  
                    <span style="color:#ffffff;cursor: pointer;" @click="getClassList">课程 </span>
                </span>
                <span>
                    <span> > </span>
                    <span v-if="isChosen !== true"  style="color:#ffffff">{{ select_courseName }}</span>
                    <span v-else ></span>
                </span>
            </div>
           
        </div>
        <div class="main">
            <div class="course-left">

                <div class="container">
                    <router-view v-if="activeName === 'teacherFeatured' || 'teacherCourseIndex'" :courseInfos="courseInfos"
                        :nodeIndex="nodeIndex" :chapterIndex="chapterIndex" @handleList="handleList"
                        :select_list="select_list" :module_list="module_list" @handleSave="handleSave" @savaData="savaData"
                        @savaId="savaId" :searchInput="searchInput" :zhangName="zhangName" :jieName="jieName" :courseTempList="courseTempList"
                        @updateTempList="updateTempList" />
                    <router-view v-else />
                </div>
            </div>
            <div class="course-right">
                <div class="select_class">
                    <span class="tip">课程目录</span>
                    <div class="dark-select">
                        <el-select v-model="select_course" placeholder="请选择课程" :popper-append-to-body="false" clearable
                            class="provinces_select" @change="chooseCourse">
                            <el-option v-for="item in teacherCourseList" :key="item.course_id" :label="item.course_name"
                                :value="item.course_id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="item-title" style="cursor: pointer;" :class="isChosen === true ? 'choseAll' : ''" @click="choseAll">
                    <span ><i class="iconfont play-icon" style="margin-right: 6px;">&#xe719;</i></span> <span
                        class="text">课程总览</span>
                </div>
                <el-scrollbar :native="false">
                    <div class="zhang-jie">
                        <div class="zhang-jie-item" :class="setClass(zhangIndex)"
                            v-for="(zhangItem, zhangIndex) in courseZhangJie" :key="zhangItem.name">
                            <div class="zhang" :class="{ currentZhang: (chapterIndex == zhangIndex && isChosen==false) }"
                                :title="`第${zhangIndex + 1}章：${zhangItem.name}（${zhangItem.children.length}节）`">
                                <span class="text">第{{ zhangIndex + 1 }}章：{{ zhangItem.name }}（{{ zhangItem.children.length
                                }}节）</span>
                            </div>
                            <div class="jie-box">
                                <div class="jie-inside-box">
                                    <div class="jie"
                                        :class="{ current: currentJie === jieIndex && chapterIndex == zhangIndex }"
                                        v-for="(jieItem, jieIndex) in zhangItem.children"
                                        @click="clickJie(zhangIndex, jieIndex,zhangItem.name,jieItem.name)"
                                        :title="`第${jieIndex + 1}节   ${jieItem.name}`" :key="jieIndex">
                                        <div class="text"
                                            :class="{ class_name: jieIndex != (zhangItem.children.length - 1), class_name1: jieIndex !== 0 }">
                                            第 {{ jieIndex + 1 }} 节 {{ jieItem.name }}
                                </div>
                                        <div class="button_box" style="width: 100%;height: 50px;display: flex;align-items: center;justify-content: end;">
                                            <el-button class="button" @click.stop="coursePush(zhangIndex,jieIndex)" :style="{color:jieItem.pusher?'#FF3432':'#FFFFFF '}"><i class="iconfont" style="padding-right: 5px;font-size: 14px;">&#xe75f;</i>{{ jieItem.pusher?'取消推送':'课程推送' }}</el-button>
                                            <el-button class="button" @click="beginClass(`${select_courseName} > ${zhangItem.name} > ${jieItem.name}`,zhangIndex,jieIndex)"><i class="iconfont" style="padding-right: 5px;font-size: 14px;">&#xe6ca;</i>开始上课</el-button>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-scrollbar>
            </div>

        </div>
        <el-dialog
            title="选择班级"  custom-class="class_dialog"
            :visible.sync="classVisible"
            width="28%"
            :before-close="closeClass">
                <div class="class_list_box" >
                    <el-radio-group v-model="classObject.class_id">
                        <el-radio :label="item.c_id"  v-for="item in classList" :key="item.c_id">{{ item.c_name }}</el-radio>
                    </el-radio-group>
                
                </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="closeClass">取 消</el-button>
                <el-button style="background-color:#4F7BFD ;color: #fff;" type="primary" @click="confirmClass">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import teacherIndex from 'components/teacherCourse/teacherIndex.vue'
import teacherFeatured from 'components/teacherCourse/teacherFeatured.vue'
import teacherCourseWare from 'components/teacherCourse/teacherCourseWare.vue'
import teacherTextbook from 'components/teacherCourse/teacherTextbook.vue'
import teacherMicroLesson from 'components/teacherCourse/teacherMicroLesson.vue'
import teacherAnimation from 'components/teacherCourse/teacherAnimation.vue'
import _ from "underscore";
import { mapActions } from "vuex";
import {wssUrl} from "../../config/wss";
import {sendWsData} from "@/utils/utils";
export default {
    name: "TeacherCourseLayout",
    components: {
        teacherIndex,
        teacherFeatured,
        teacherCourseWare,
        teacherTextbook,
        teacherMicroLesson,
        teacherAnimation
    },
    data() {
        return {
            isChosen: true,
            activeName: 'teacherCourseIndex',
            searchInput: '',
            //选择的课程
            select_course: '',
            select_courseName:"",
            teacherCourseList: [],
            //章节
            courseZhangJie: [],
            currentJie: '',
            //总管理员分配的章节
            allocatedCourse: [],
            allocatedCourseNum: null,
            //课程介绍
            courseInfos: {},
            zhang_arr: [],
            nodeIndex: 0,
            chapterIndex: 0,
            select_list: [],
            select_list1: [],
            module_list: [],
            dataObj: {},
            id: '',
            courseTempList: [],
            breadcrunmData: [ "课程", ],
            //精选课程
            featuredCourseList: [
                {
                    class: 'courseware',
                    icon: '&#xe737;',
                    title: '课件',
                    index: 1,
                    mtype: 0,
                },
                {
                    class: 'textbook',
                    icon: '&#xe71b;',
                    title: '教材',
                    index: 2,
                    mtype: 0,
                },
                {
                    class: 'micro-lesson',
                    icon: '&#xe71d;',
                    title: '微课',
                    index: 3,
                    mtype: 0,
                },
                {
                    class: 'animation',
                    icon: '&#xe72f;',
                    title: '教学设计',
                    index: 4,
                    mtype: 0,
                },
                {
                    class: 'test-center',
                    icon: '&#xe738;',
                    title: '测试中心',
                    index: 5,
                    mtype: 0,
                },
                {
                    class: 'training-center',
                    icon: '&#xe71c;',
                    title: '实训中心',
                    index: 6,
                    mtype: 0,
                },
                {
                    class: 'supporting-material',
                    icon: '&#xe72e;',
                    title: '配套材料',
                    index: 7,
                    mtype: 0,
                }, {
                    class: 'person-resource',
                    icon: '&#xe72d;',
                    title: '个人资源',
                    index: 8,
                    mtype: 0,
                }, {
                    class: 'prepare-lessons',
                    icon: '&#xe72c;',
                    title: '备课',
                    index: 9,
                    mtype: 0,
                }
            ],
            activeFeaturedIndex: 9,
            showResourseList: [],
            cKejian:[],
            cJiaocai:[],
            cWeike:[],
            cJiaoan:[],
            testCenter:[],
            practiceCenter:[],
            select_course_id:"",
            chapterIndex:"",
            nodeIndex:"",
            zhangName: '',
            jieName: '',
            classList:[],
            classObject:{
                class_id:void 0,
                class_name:""
            },
            classVisible:false,
            course_record_id: '',
            wsIns: null,
            wsTimer: null,
            class_id:null


        }
    },
    computed: {
            courseCrumbs() {
                let name = '';
                switch (this.typeId) {
                    case 1:
                        name = '课件';
                        break;
                    case 2:
                        name = '教材';
                        break;
                    case 3:
                        name = '微课';
                        break;
                    case 4:
                        name = '教学设计';
                        break;
                    case 5:
                        name = '配套材料';
                        break;
                    case 6:
                        name = '测试中心';
                        break;
                    case 7:
                        name = '实训中心';
                        break;
                }
                return name;
            }
        },
    created() {
        this.activeName = this.$route.meta.tabName;
        this.getTeacherCourseList();
        this.module_list = new Array(14).fill({})
        this.select_list = this.module_list;
        if(localStorage.getItem("isChosen")==null){
            localStorage.setItem("isChosen" ,this.isChosen)
        }else{
            this.isChosen=localStorage.getItem('isChosen')=="false"?false:true
            this.chapterIndex = localStorage.getItem('teacherChapter');
            this.nodeIndex = localStorage.getItem('teacherNode');
            this.currentJie = Number(this.nodeIndex);
                 
        }
        if (this.activeName === 'teacherFeatured' && this.isChosen == true) {
            this.isChosen = false;
            this.chapterIndex = localStorage.getItem('teacherChapter');
            this.nodeIndex = localStorage.getItem('teacherNode');
           this.currentJie = Number(this.nodeIndex);
        }
        

        this.setKey()
        this.getClassList()
        this.websocketInit()
    },
    watch: {
        $route(route) {
            if (route.name === 'teacherCourseIndex') {
                this.activeName = 'teacherCourseIndex';
                this.isChosen = true;
                this.currentJie = '';
            } else if (route.name === 'teacherFeatured') {
                this.activeName = 'teacherFeatured';
                this.isChosen = false;
                // this.currentJie = 0;
            }
            this.setKey()
        }
        
    },
    methods: {
        ...mapActions([
            'setCourseAttrC'
        ]),

        setKey() {
            if (this.$route.name === 'teacherCourseWareDetail') {
                document.oncontextmenu = function () {
                    return false
                }
                document.onkeydown = function () {
                    if (window.event && window.event.keyCode === 123) {
                        // alert("F12被禁用");
                        // event.keyCode = 0;
                        event.returnValue = false;
                    }
                    if (window.event && window.event.keyCode === 13) {
                        // alert("3333");
                        window.event.keyCode = 505;
                    }
                    if (window.event && window.event.keyCode === 8) {
                        // alert(str+"\n请使用Del键进行字符的删除操作！");
                        window.event.returnValue = false;
                    }
                }
            } else {
                document.oncontextmenu = function () {
                    return true
                }
                document.onkeydown = function () {
                    if (window.event && window.event.keyCode === 123) {
                        event.returnValue = true;
                    }
                    if (window.event && window.event.keyCode === 13) {
                        window.event.keyCode = 505;
                    }
                    if (window.event && window.event.keyCode === 8) {
                        window.event.returnValue = true;
                    }
                }
            }
        },
        setClass(index) {
            
            if (this.zhang_arr.indexOf(index) == -1) {
                return 'isAllocatedClass';
            } else {
                return '';
            }
           

        },
        choseAll() {
            this.isChosen = true;
            this.chapterIndex = '';
            this.nodeIndex = '';
            this.currentJie = '';
            this.$router.push({
                path: '/qualityCourse/teacher/index',
                query: {
                    course_id: this.select_course
                }
            })
        },
        //选择课程
        chooseCourse(val) {
            this.currentJie = 0;
            this.chapterIndex = 0;
            this.nodeIndex = 0;
            this.module_list = new Array(14).fill({})
            this.select_list = this.module_list;
            this.searchInput = '';
            this.$router.push({
                path: '/qualityCourse/teacher/index',
                query: {
                    course_id: val,
                },
            });
            localStorage.setItem("course_id",this.select_course)
            setTimeout(()=>{
                this.getCourseInfo(val);
                this.getTeacherCourseList();
            },500)
        },
        getTeacherCourseList() {
            this.$thttp.axiosGet(this.$api.showTeaCourse, (res) => {
                if (res.code === 200) {
                    this.teacherCourseList = res.data.course_list;
                    if (this.$route.query.course_id) {
                        this.select_course = Number(this.$route.query.course_id);
                    } else {
                        this.select_course = res.data.course_list[0].course_id;
                        this.$router.push({
                            query: {
                                course_id: this.select_course,
                            },
                        });
                    }
                    if (this.select_course) {
                   setTimeout(()=>{
                    this.getCourseInfo(this.select_course);
                   },600)
                        // this.getCourseTempList()  暂时先注释掉  可能不需要请求
                        // console.log("222222222");
                    }
                    this.allocatedCourse = JSON.parse(res.data.course_data);
                    let zhang_arr = [];
                    _.each(this.allocatedCourse, (_item) => {
                        if (Number(_item.course_id) === Number(this.select_course)) {
                            zhang_arr.push(_item.zhang_arr);
                        }
                    });
                    this.zhang_arr = zhang_arr
                } else {
                    this.$message.warning(res.msg)
                }
                let obj=this.teacherCourseList.find(item=>item.course_id==this.select_course)
         
                    this.select_courseName=obj.course_name
                
            })
        },
        //获取课程详情
        getCourseInfo(courseId) {
            console.log("Number(localStorage.getIte",Number(localStorage.getItem("class_id")));
            
            let params = {
                id: courseId,
                class_id: Number(localStorage.getItem("class_id"))
            };
            if (isNaN(params.class_id)) {
                    // 如果 class_id 无效，从 param 对象中删除 class_id 属性
                    delete params.class_id;
                }
            this.$thttp.axiosGetBy(this.$api.courseinfo, params, (res) => {
                if (res.code === 200) {
                    this.courseZhangJie = res.data.course_content;
                    this.courseInfos = res.data;
                    
                }
            }, (error) => {
                console.log(error);
            })
        },
        clickJie(index, jIndex,zhangName,jieName) {
            if(!Number(localStorage.getItem("class_id"))){
                // this.$message.warning("请选择班级")
                console.log("pppppppp",123456);
                
                this.selectClass()
            }
            this.searchInput = '';
            if (this.zhang_arr.indexOf(index) !== -1) {
                this.isChosen = false;
                this.chapterIndex = index;
                this.nodeIndex = jIndex;
                localStorage.setItem('isChosen',false)
                localStorage.setItem('teacherChapter', index);
                localStorage.setItem('teacherNode', jIndex);
                // console.log("zhangName",zhangName,JieName);
                localStorage.setItem("course_id",this.select_course)
                localStorage.setItem("zhangName",zhangName)
                localStorage.setItem("jieName",jieName)
                this.zhangName=zhangName,
                this.jieName=jieName,
                this.getCourseTempList()
                this.$router.push({
                    path: '/qualityCourse/teacher/teacherFeatured',
                    query: {
                        course_id: this.select_course,
                    }
                });
                this.currentJie = jIndex;
            } else {
                this.$message({
                    type: 'warning',
                    message: '该节内容未授权',
                    duration: 1000
                });
            }
        },
        handleClick(tab, event) {
            this.searchInput = '';
            this.$router.push({
                name: tab.name,
                query: {
                    course_id: this.select_course
                },
            })
        },
        handleList(val) {
            this.select_list = val;
            this.module_list = this.select_list;
        },
        savaData(val) {
            this.dataObj = val;
        },
        savaId(val) {
            this.id = val;
        },
        formatData(dataList) {
            let obj = {}
            dataList.forEach(item => {
                if (JSON.stringify(item) !== "{}") {
                    let newIndex = dataList.indexOf(item)
                    //处理精选课程
                    if (item.mtype == 0) {
                        switch (item.index) {
                            case 1:
                                obj = this.dataObj.cKejian[0];
                                break;
                            case 2:
                                obj = this.dataObj.cJiaocai[0];
                                break;
                            case 3:
                                obj = this.dataObj.cWeike[0];
                                break;
                            case 4:
                                obj = this.dataObj.cDonghua[0];
                                break;
                            case 5:
                                obj = this.dataObj.cPeitao[0];
                                break;
                            case 6:
                                obj = this.dataObj.testCenter[0];
                                break;
                            case 7:
                                obj = this.dataObj.practiceCenter[0];
                                break;
                        }
                        let newObj = Object.assign(dataList[newIndex], obj);
                        dataList[newIndex] = newObj;
                    } else if (item.mtype == 1) {//处理配套材料
                        switch (item.id) {
                            case 1:
                                obj = this.dataObj.cZhishidian[0];
                                break;
                            case 2:
                                obj = this.dataObj.cSucaiku[0];
                                break;
                            case 3:
                                obj = this.dataObj.cAnliku[0];
                                break;
                            case 4:
                                obj = this.dataObj.cPeiWeike[0];
                                break;
                            case 5:
                                obj = this.dataObj.cXiangguanwenzhang[0];
                                break;
                            case 6:
                                obj = this.dataObj.cPersonResource[0];
                                break;
                        }
                        let newObj = Object.assign(dataList[newIndex], obj);
                        dataList[newIndex] = newObj;
                    }
                }
            })
        },
        handleSave(val) {
            let dataList = JSON.parse(JSON.stringify(this.select_list));
            this.formatData(dataList)
            let arr = [];
            dataList.forEach((item, index) => {
                if (JSON.stringify(item) !== "{}") {
                    let obj = {
                        type: item.ctype,
                        id: item.id,
                        index: index,
                    }
                    if (item.icon) {
                        obj.oldIndex = item.oldIndex;
                    }
                    arr.push(obj)
                }
            })
            let param = {
                course_id: this.select_course,
                course_chapter: this.chapterIndex,
                course_node: this.nodeIndex,
                course_content: JSON.stringify(arr)
            }
            if (this.id) {
                param.id = this.id;
            }
            if (val) {
                this.$thttp.axiosPost(this.$api.saveCourseCustom, param, res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                    } else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        //获取选择模板列表
        getCourseTempList() {
            let param = {
                course_id: this.select_course,
                course_chapter: this.chapterIndex,
                course_node: this.nodeIndex
            }
            this.$thttp.axiosGetBy(this.$api.course_getCourseTemp, param, res => {
                if (res.code === 200) {
                    this.courseTempList = res.data;
                } else {
                    this.$message.warning(res.msg)
                }
            })
        },
        updateTempList() {
            this.getCourseTempList()
        },
        getResourceList(index) {
            this.activeFeaturedIndex = Number(index-1)
            this.showResourseList = [];
                switch (index) {
                    case 1:
                        this.showResourseList = this.cKejian;
                        break;
                    case 2:
                        this.showResourseList = this.cJiaocai;
                        break;
                    case 3:
                        this.showResourseList = this.cWeike;
                        break;
                    case 4:
                        this.showResourseList = this.cJiaoan;
                        break;
                    case 6:
                        this.showResourseList = this.testCenter;
                        break;
                    case 7:
                        this.showResourseList = this.practiceCenter;
                        break;
                    case 8:
                        this.$router.push({
                            path: '/qualityCourse/teacher/teacherMatingDetail',
                            query: {
                                course_id: this.select_course,
                                zhangIndex: this.chapterIndex,
                                jieIndex: this.nodeIndex,
                            }
                        })
                        break;
                        case 9:
                        this.$router.push({
                            path: '/qualityCourse/teacher/teacherMatingDetail',
                            query: {
                                course_id: this.select_course,
                                zhangIndex: this.chapterIndex,
                                jieIndex: this.nodeIndex,
                            }
                        })
                        break;
                }

        },
        websocketInit() {
    
                
                this.wsIns = new WebSocket(wssUrl())
                this.wsIns.onopen = () => {
                    console.log("连接成功")
                    //绑定
                    this.wsIns.send(sendWsData('bind'))
                    if (this.wsTimer) clearInterval(this.wsTimer);
                    this.wsTimer = setInterval(() => {
                        const sendMsg = sendWsData("ping");
                        this.wsIns.send(sendMsg);
                    }, 50000);
                }
                //断开之后重连
                this.wsIns.onclose = () => {
                    console.log("已断开连接，尝试重新连接")
                    this.websocketInit()
                }
            },
        wsNotice(data) {
                const send_data_body = {
                    ...data,
                    c_id:  Number(localStorage.getItem("class_id"))
                }
                this.wsIns.send(sendWsData('notice', send_data_body))
            },
        getClassList(){
            this.$router.push("/qualityCourse/teacher/index")
        },
        beginClass(location,zhangIndex,jieIndex){
            console.log("location",location);
            // if(! Number(localStorage.getItem("class_id"))){
            //     // this.$message.warning("请选择班级")
            //     this.selectClass()
            // }else{
                let params = {
                    c_id:  Number(localStorage.getItem("class_id")),
                    course_id:this.select_course,
                    chapter_sign:zhangIndex,
                    node:jieIndex
                }
                this.$shttp.axiosPost(this.$api.startCourse, params, (res) => {
                    if (res.code === 200) {
                        console.log("res", res.data)
                        //通知上课
                        this.wsNotice(res.data)
                        this.course_record_id = res.data.course_record_id
                        this.$store.dispatch('setRefreshVal', 0);
                        this.$message.success(res.msg)
                        let routeData = this.$router.resolve({
                          path:'/course/inClass',
                          query: {
                            classId:  Number(localStorage.getItem("class_id")),
                            className: localStorage.getItem("class_name"),
                            id: res.data.course_id,
                            recordId: this.course_record_id,
                            chapter:  this.chapterIndex, 
                            node:  this.nodeIndex,
                            location
                          }
                        })
                        window.open(routeData.href, '_blank')
                    } else {
                        this.$message.warning(res.msg)
                    }
                }, (err) => {
                    console.log(err)
                })
            // }
            

        },
        coursePush(zhangIndex,jieIndex){
            
            // 课程推送
            let param={
                course_id: this.select_course, 
                class_id:  Number(localStorage.getItem("class_id")), 
                course_chapter: Number(zhangIndex), 
                course_node: Number(jieIndex)
                }
               
                this.$shttp.axiosPost(this.$api.jdCoursePush, param, (res) => {
                if (res.code === 200) {
                  this.getCourseInfo(this.select_course)
                }
            }, (err) => {
                console.log(err);
            })
        },
        selectClass(){
            if(this.classList.length>0){``
                this.classVisible=true
            }else{
                this.$confirm('当前暂无班级, 是否前往创建?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    this.$router.push("/qualityCourse/educational")
                }).catch(() => {
                     
                });
            }
              

            },
        getClassList() {
            let param = {
                paging:2
            }
            this.$shttp.axiosGetBy(this.$api.cl_list, param, (res) => {
                if (res.code === 200) {
                    this.classList = res.data;  
                }
            }, (err) => {
                console.log(err);
            })
        },
        confirmClass(){
            if(!this.classObject.class_id){
                this.$message.warning("请选择班级")
                return
            }
            let obj=this.classList.find(item=>item.c_id==this.classObject.class_id)
                if(obj){
                    this.classObject.class_name=obj.c_name
                }
         
            this.selectClassInfo()
          
        },
        selectClassInfo(){
                let params={
                    course_id:this.select_course,
                    class_id:this.classObject.class_id
                }
                console.log(params,"pppp");
                
                this.$shttp.axiosPost(this.$api.jdCourseSaveSelectionClass , params, (res) => {
                    if (res.code === 200) {
                        localStorage.setItem("class_id",this.classObject.class_id)
                        localStorage.setItem("class_name",this.classObject.class_name)
                        window.location.reload()
                        this.classVisible=false
                        this.$message.success("设置成功!")      
                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                    }, (err) => {
                        console.log(err)
                })
            },
        closeClass(){
            this.classVisible=false
        },
    },
    beforeDestroy(){
           localStorage.removeItem("isChosen")
         
       }
}
</script>

<style scoped lang="scss">
.teacher-index-container {
    width: 100%;
    height: 100%;
    box-sizing: border-box;

    .header {
        width: 100%;
        height: 42px;
        background-color: #282828;
        padding: 0 100px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        color: #FFFFFF;

    }

    .main {
        display: flex;
        width: 100%;
        // height: calc(100vh - 112px);
   

        .course-left {
            width: 0;
            flex: 1;
            // height: 100%;
            min-height: calc(100vh - 112px);
            display: flex;
        


            .container {
                width: 0;
                flex: 1;
                height: 100% !important;
           
        

            }

            .resource_navigation {
                width: 80px;
                height: 100%;
                background: #333333;
                padding: 15px 0;
                box-sizing: border-box;

                .featured-right {
                    .resource {
                        .resourse_item {

                            ::v-deep .inner-box {
                                width: 100%;
                                color: #999999;
                                height: 90px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                flex-direction: column;

                                .resourse_title {
                                    margin-top: 10px;
                                    font-size: 14px;
                                }


                            }

                            ::v-deep .active_resourse_item {
                                background-color: #1E1E1E !important;
                                color: #FFFFFF;

                            }


                        }


                    }

                }
            }




        }

        .course-right {
            width: 340px;
            min-height: calc(100vh - 112px);
            background-color: #2D2D2D;
            color: #999999;
            // overflow-y: auto;

            .select_class {
                width: 100%;
                height: 80px;
                // background-color: pink;
                display: flex;
                align-items: center;
                padding: 24px;
                box-sizing: border-box;

                .tip {
                    padding-right: 6px;
                    font-size: 16;
                }
            }

            .item-title {
                height: 53px;
                // background-color: pink;
                display: flex;
                align-items: center;
                padding: 0px 24px;
                box-sizing: border-box;
                font-weight: 400;
                font-size: 16px;
                line-height: 19px;
                text-align: left;
                font-style: normal;
                text-transform: none;
                color: #999999;
            }

            .choseAll {
                color: #FFFFFF !important;
                background-color: #282828;
            }

            .zhang-jie {
                max-height: calc(100vh - 280px) !important;

                .zhang-jie-item {
                    width: 100%;
                    // padding: 10px 0;
                    // padding-left: 24px;
                    // background-color: pink;
                    // background-color: pink;
                    box-sizing: border-box;


                    .zhang {
                        width: 320px;
                        display: inline-block;
                        white-space: nowrap; 
                        overflow: hidden;
                        text-overflow: ellipsis; 
                        padding: 10px 0;
                        box-sizing: border-box;
                        padding-left: 24px;
                        font-family: PingFang SC, PingFang SC;
                        font-weight: 400;
                        font-size: 16px;
                    }
                    .currentZhang{
                        color: #FFFFFF;
                    }

                    .jie-box {

                        .jie {
                            padding-top: 10px;
                            height: 73px;
                            display: flex;
                            align-items: center;
                            flex-direction: column;
                            cursor: pointer;
                            box-sizing: border-box;
                            color: #999999 !important;
                            position: relative;
                            /* 确保伪元素定位相对于父元素 */
                            padding-left: 54px;
                            font-size: 16px;
                            /* 当有多个 .jie 元素时，处理连接线的显示 */
                            .class_name::after {
                                content: '';
                                position: absolute;
                                width: 1px;
                                height: 28px;
                                /* 延长线的长度，确保连接到下一个 .jie 元素的顶部 */
                                background-color: rgba(255, 255, 255, 0.50) !important;
                                left: 31.5px !important;
                                /* 让线从圆圈的中心点位置开始 */
                                top: 30px;
                                /* 线的起点在当前 .jie 元素的底部 */
                                z-index: 100 !important;

                            }

                            .class_name1::before {
                                content: '';
                                position: absolute;
                                width: 1px;
                                height: 28px;
                                /* 延长线的长度，确保连接到下一个 .jie 元素的顶部 */
                                background-color: #999999;
                                left: 31.5px !important;
                                /* 让线从圆圈的中心点位置开始 */
                                top: -15px;
                                /* 线的起点在当前 .jie 元素的底部 */

                            }
                            .text{
                                width: 270px;
                                display: inline-block;
                                white-space: nowrap; 
                                overflow: hidden;
                                text-overflow: ellipsis; 
                            }
                            .button_box{
                                width: 100%;
                                height: 50px;
                                display: flex;
                                align-items: center;
                                justify-content: end;
                                padding-right: 20px;
                                box-sizing: border-box;
                                .button{
                                    width: 90px;
                                    height: 20px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    border-radius: 20px;
                                    font-size: 12px;
                                    background: #383838;
                                    border: none;
                                    color: #4c73e4;
                                    &:nth-of-type(1){
                                        color: #fff;
                                    }
                                }
                            }

                        }

                        .jie::before {
                            content: '';
                            display: inline-block;
                            width: 15px;
                            height: 15px;
                            border: 1px solid rgba(255, 255, 255, 0.5);
                            border-radius: 50%;
                            position: absolute;
                            left: 24px;
                            top: 30%;
                            transform: translateY(-50%);
                            box-sizing: border-box;
                        }

                        .current {
                            color: #FFFFFF !important;
                            background-color: #282828;
                        }
                        



                        .current::after {
                            content: '';
                            display: inline-block;
                            width: 8px;
                            height: 8px;
                            background-color: #FFFFFF;
                            /* 实心圆颜色 */
                            border-radius: 50%;
                            position: absolute;
                            left: 9%;
                            top: 30%;
                            transform: translate(-39%, -50%);


                        }

                    }
                }
                .isAllocatedClass {
                        color:rgba(153, 153, 153,.5);
                        .jie-box{
                           .jie {
                            cursor: pointer;
                            color:rgba(153, 153, 153,.5) !important;

                        }
                    }

                        
                    }
            }
        }
    }

}

::v-deep .el-input__inner {
    height: 36px;
    background-color: #1E1E1E;
    color: #FFFFFF ;
}

::v-deep .el-select .el-input.is-focus .el-input__inner {
    border-color: #2D2D2D !important;
}

::v-deep .el-select-dropdown .el-popper {
    background-color: #2D2D2D !important;
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
    color: #999999 !important;

}

.dark-select ::v-deep input::-webkit-input-placeholder {
    color: rgba(255, 255, 255, 0.50);
}

.dark-select ::v-deep input::-moz-input-placeholder {
    color: rgba(255, 255, 255, 0.50);
}

.dark-select ::v-deep input::-ms-input-placeholder {
    color: rgba(255, 255, 255, 0.50);
}

.dark-select ::v-deep .el-select,
.dark-select ::v-deep .el-input,
.dark-select ::v-deep .el-input__inner {
    background-color: rgba(255, 255, 255, 0.04);
    color: rgba(255, 255, 255, 0.50);
    border: none;
    /* 去掉边框 */
    border-radius: 4px;
    text-align: left;
}

.dark-select ::v-deep .el-input__inner:hover {
    background-color: rgba(255, 255, 255, 0.12);
}

.dark-select ::v-deep .el-select .el-input .el-select__caret {
    color: #748092;
    background-color: #FFFFFF;
    width: 20px;
    height: 20px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
}

.dark-select ::v-deep .el-popper[x-placement^="bottom"] .popper__arrow::after {
    border-bottom-color: rgba(43, 45, 55, 0.80);
    z-index: 9999;
}

.dark-select ::v-deep .popper__arrow {
    border: none;
}

.dark-select ::v-deep .el-select-dropdown {
    border: none !important;
    background: #2D2D2D !important;
    box-shadow: 1px 4px 20px 4px rgba(0, 0, 0, 0.25), 1px 4px 20px 4px rgba(0, 0, 0, 0.25);
    z-index: 9999;
    left: -63px !important;
}

.dark-select ::v-deep .el-select-dropdown__item {
    color: rgba(255, 255, 255, 0.50) !important;
    position: relative;
    /* 确保伪元素定位相对于父元素 */
    padding-left: 30px;
    /* 增加左侧留白，为伪元素空心圆留位置 */
    line-height: 40px;
    /* 调整行高以居中显示 */
    cursor: pointer;
    /* 鼠标指针样式 */
}

.dark-select ::v-deep .el-select-dropdown__item.selected span {
    color: rgba(255, 255, 255, 0.80) !important;
}

.dark-select ::v-deep .el-select-dropdown__item.hover {
    background-color: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.80) !important;
}

.dark-select ::v-deep .el-scrollbar__bar.is-vertical {
    width: 10px;
    top: 2px;
}

.dark-select ::v-deep .el-select-dropdown__wrap {
    max-height: 329px;
    width: 300px;
}

// .dark-select ::v-deep .el-select-dropdown__item {
//     position: relative; /* 确保伪元素定位相对于父元素 */
//     padding-left: 20px; /* 增加左侧留白，为伪元素空心圆留位置 */
//     line-height: 40px; /* 调整行高以居中显示 */
//     cursor: pointer; /* 鼠标指针样式 */

//     /* 其他样式保持不变 */
//     color: rgba(255, 255, 255, 0.50) !important;
// }

.dark-select ::v-deep .el-select-dropdown__item.selected {
    color: rgba(255, 255, 255, 0.80) !important;
}

.dark-select ::v-deep .el-select-dropdown__item::before {
    content: '';
    display: inline-block;
    width: 18px;
    height: 18px;
    border: 1px solid rgba(255, 255, 255, 0.5);
    border-radius: 50%;
    position: absolute;
    left: 6px;
    /* 调整位置以与文本对齐 */
    top: 50%;
    transform: translateY(-50%);
    box-sizing: border-box;
    /* 边框大小不影响元素尺寸 */
}

.dark-select ::v-deep .el-select-dropdown__item.selected::before {
    background-color: transparent;
    /* 空心圆背景透明 */
    border-color: rgba(255, 255, 255, 0.8);
    /* 边框颜色 */
}

.dark-select ::v-deep .el-select-dropdown__item.selected::after {
    content: '';
    display: inline-block;
    width: 9px;
    height: 9px;
    background-color: #FFFFFF;
    /* 实心圆颜色 */
    border-radius: 50%;
    position: absolute;
    left: 4%;
    top: 50%;
    transform: translate(-8%, -50%);
}
.el-radio{
      margin-bottom: 40px;
    }
    ::v-deep .el-radio__label{
      min-width: 100px;
      display: inline-block;
        background: rgb(242, 246, 250) !important;
        color: #333;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E6E7EB;
        padding: 10px  15px;
        margin-left: 5px;
       
    }
    ::v-deep .el-radio__input.is-checked+.el-radio__label{
        border: 1px solid #4F7BFD;
        color: #333 !important;
    }
    .class_list_box{
        height: 400px;
        overflow-y: auto;
        padding-top: 15px ;
        box-sizing: border-box;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #E6E7EB;
    }
    ::v-deep .el-radio-group{
        height: 98%;
       
        padding:20px 10px;
        padding-left: 15px;
        box-sizing: border-box;
    }
    .dialog-footer{
        display: flex;
        justify-content: end;
        .el-button{
            width: 88px;
            height: 36px;
            background: #F2F4F7;
            border-radius: 4px 4px 4px 4px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #3E3E3E;
            line-height: 16px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            display: flex;
            align-items: center;
            justify-content: center;
            
        }
    }
   
</style>
